// extracted by mini-css-extract-plugin
export default {"container":"nT-z","title":"oT-z","link":"pT-z"};